import { Api } from 'utils';

class ReferralService {
	
	static save = async (params?: any) => Api.createResponse('referral/save',params);

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/referrals/',params),
		updateAmount: async (params?: any) => Api.createResponse('admin/referrals/update-amount',params),
		pay: async (params?: any) => Api.createResponse('admin/referrals/pay',params),
		view: async (params?: any) => Api.createResponse('admin/referrals/view',params),
		download: async (params?: any) => Api.createResponse('admin/referrals/download',params),
	}

}

export default ReferralService;